import {
  Avatar,
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useContext, useEffect } from "react";
import moment from "moment";
import { AllergyContext } from "../Allergy";
import { calculateAge } from "../../../utilis/methods/dateMethods";
import { getPatientGroupingDisplay } from "../../../utilis/methods/patientGrouping";
import { EmrContext } from "../..";
import DetailsSkeleton from "../../../utilis/component/DetailsSkeleton";
import PatientVipChip from "../../../utilis/component/PatientVipChip";
// const avatar =
//   "https://img.freepik.com/free-psd/3d-illustration-person-with-sunglasses_23-2149436188.jpg?size=626&ext=jpg";

function PatientDetailsComponent() {
  const { patientData, dataLoading } = useContext(EmrContext);
  console.log("patientData", patientData);
  const { setSuccess, list } = useContext(AllergyContext);
  const checkDateFormat = (date: string): string | null => {
    const formats = ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY/MM/DD", "YYYY-MM-DD"];

    for (let format of formats) {
      if (moment(date, format, true).isValid()) {
        return format; // Returns the matched format
      }
    }
    return null;
  };
  const showAge = (dob: string): string => {
    const format = checkDateFormat(dob);

    if (dob) {
      if (format) {
        const age = calculateAge(moment(dob, format).format("YYYY-MM-DD"));
        const ageTypeKey =
          age.age > 1
            ? age.ageType
            : (`${age.ageType}1` as keyof typeof dateType);
        return `${age.age} ${dateType[ageTypeKey]}`;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  useEffect(() => {
    setSuccess(true);
  }, []);

  return dataLoading ? (
    <div className="pt-3">
      <DetailsSkeleton count={8} variant="rounded" />
    </div>
  ) : (
    <div className="relative pt-3 w-full">
      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.background.paper,
        })}
        className="absolute top-0 left-4 w-[130px] px-3 rounded"
      >
        Patient details
      </Box>
      <Paper className="pt-4 px-3 h-fit grid grid-cols-12">
        <div className="col-span-11 relative">
          <div className="absolute right-2 flex gap-1">
            <PatientVipChip isVip={patientData?.pmaster?.isVip} />
            {Boolean(list?.length) && (
              <Chip
                color="warning"
                size="small"
                label="Allergic"
              />
            )}
          </div>
          <Table size="small" sx={{ width: "100%" }}>
            <TableBody>
              <TableRow>
                <TableCell sx={{ border: 0 }} align="left">
                  NAME
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  : {patientData?.pmaster?.patientName || ""}
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  DOCTOR
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  : {patientData?.encounter?.doctorName || ""}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ border: 0 }} align="left">
                  EMR NO/REG NO
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  : {patientData?.pmaster?.patientId || ""}
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  DEPARTMENT
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  : {patientData?.encounter?.departmentName || ""}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ border: 0 }} align="left" width={120}>
                  {patientData?.pmaster?.emiratesId
                    ? "CIVIL ID"
                    : patientData?.pmaster?.gccId
                      ? "GCC ID"
                      : patientData?.pmaster?.passportNum
                        ? "PASSPORT ID"
                        : "CIVIL ID"}
                </TableCell>

                <TableCell sx={{ border: 0 }} align="left">
                  : {patientData?.pmaster?.emiratesId ?? patientData?.pmaster?.gccId ?? patientData?.pmaster?.passportNum}
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  INSURANCE
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  : {patientData?.insurancePatient?.insurance_name || ""}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ border: 0 }} align="left">
                  AGE
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  : {showAge(patientData?.pmaster?.dob as string) || ""} |{" "}
                  {patientData?.pmaster?.gender || ""}
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  PLAN & EXPIRY
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left">
                  :{" "}
                  {patientData?.insurancePatient?.policyValidity
                    ? moment(
                      patientData?.insurancePatient?.policyValidity
                    ).format("DD-MM-YYYY")
                    : ""}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ border: 0 }} align="left">
                  GROUPING
                </TableCell>
                <TableCell sx={{ border: 0 }} align="left" colSpan={3}>
                  : {getPatientGroupingDisplay(patientData) || ""}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div className="flex justify-end">
          <Avatar
            src={patientData?.image || ""}
            variant="rounded"
            alt="Patient image"
            sx={{ width: 90, height: 90 }}
          >
            <Typography variant="h5">
              {`${patientData?.pmaster?.patientName[0]}${patientData?.pmaster?.lastName[0]}`.toUpperCase()}
            </Typography>
          </Avatar>
        </div>
      </Paper>
    </div>
  );
}

export default PatientDetailsComponent;

const dateType = {
  D: "Days",
  Y: "years",
  M: "Months",
  D1: "Day",
  Y1: "years",
  M1: "Months",
};
